<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="false"
      label-width="120px"
    />
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Gaojingshezhi',
  components: {},
  data() {
    return {
      url: '/alarm/alarmNoticeGroup/page',
      columns: [
        {
          label: '通知组名称',
          prop: 'groupName'
        },
        {
          label: '号码个数',
          prop: 'count'
        },
        {
          label: '关联枪线个数',
          prop: 'stationCount'
        },
        {
          label: '创建人',
          prop: 'createUser'
        },
        {
          label: '创建时间',
          prop: 'createDate'
        }
      ],
      // 操作栏
      handles: {
        width: 200,
        btns: [
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'alarm.group.update',
            handle: resp => {
              console.log(resp)
              this.$router.push({ path: './reviseGroup', query: { data: resp.id }})
            }
          },
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'alarm.group.details',
            handle: resp => {
              this.$router.push({ path: './groupManagementDetail', query: { data: resp.id }})
            }
          },
          {
            label: '删除',
            style: 'color:red',
            permission: 'alarm.group.delete',
            url: '/alarm/alarmNoticeGroup/delete',
            method: 'delete',
            isConfirm: true,
            confirmText: '删除后关联的电站告警通知无法下发，确认删除？',
            before: (index, record) => {
              const arr = []
              arr.push(record.id)
              return {
                ids: arr
              }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '通知组名称',
          prop: 'groupName',
          placeholder: '请输入通知组名称'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'alarm.group.add',
          type: 'primary',
          handle: resp => {
            this.$router.push('./addGroupManagement')
          }
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/groupManagement.vue